import React from 'react';
import Avatar from 'components/Avatar';
import { MenuHeader } from 'components/Menu';
import Spacer from 'components/Spacer';
import * as S from './styles';

export interface AccountMenuHeaderProps {
  /**
   * User's email address. This is used to create the user avatar.
   */
  emailAddress: string;
}

/**
 * Header element for the `AccountMenu`.
 */
const AccountMenuHeader: React.FC<AccountMenuHeaderProps> = ({
  emailAddress,
}) => (
  <S.Root forwardedAs={MenuHeader} justify="center">
    <Spacer space="10px" align="center" orientation="vertical">
      <Avatar initial={emailAddress.charAt(0)} size={50} />
      <S.Header level={2}>{emailAddress}</S.Header>
    </Spacer>
  </S.Root>
);

export default AccountMenuHeader;
